import styles from './ScoopGrid.module.scss'

/**
 * ScoopGrid - A flexible grid layout component
 *
 * @component
 * @param {Object} props - Component props
 * @param {boolean} [props.container] - If true, the component acts as a grid container
 * @param {boolean} [props.item] - If true, the component acts as a grid item
 * @param {number} [props.columns=12] - Number of columns in the grid (container only)
 * @param {string | number} [props.gap] - Gap between grid items (container only)
 * @param {string | number} [props.rowGap] - Row gap between grid items (container only)
 * @param {string | number} [props.columnGap] - Column gap between grid items (container only)
 * @param {number | 'auto'} [props.xs] - Number of columns to span at xs breakpoint (item only)
 * @param {number | 'auto'} [props.sm] - Number of columns to span at sm breakpoint (item only)
 * @param {number | 'auto'} [props.md] - Number of columns to span at md breakpoint (item only)
 * @param {number | 'auto'} [props.lg] - Number of columns to span at lg breakpoint (item only)
 * @param {number | 'auto'} [props.xl] - Number of columns to span at xl breakpoint (item only)
 * @param {React.ReactNode} props.children - Child elements
 * @param {string} [props.className] - Additional CSS classes
 * @param {Object} [props.style] - Inline styles
 * @param {...any} props - All other props are passed to the native HTML element
 */
export const ScoopGrid = ({
    container,
    item,
    columns = 12,
    gap,
    rowGap,
    columnGap,
    xs,
    sm,
    md,
    lg,
    xl,
    children,
    className = '',
    style = {},
    ...props
}) => {
    const gridClassName = [
        container && styles.container,
        item && styles.item,
        // Responsive column spans for items
        item && xs !== undefined && styles[`xs-${xs}`],
        item && sm !== undefined && styles[`sm-${sm}`],
        item && md !== undefined && styles[`md-${md}`],
        item && lg !== undefined && styles[`lg-${lg}`],
        item && xl !== undefined && styles[`xl-${xl}`],
        className,
    ]
        .filter(Boolean)
        .join(' ')

    // Build inline styles for container
    const gridStyle = { ...style }

    if (container) {
        if (columns !== 12) {
            gridStyle['--grid-columns'] = columns
        }
        if (gap !== undefined) {
            gridStyle.gap = typeof gap === 'number' ? `${gap}px` : gap
        }
        if (rowGap !== undefined) {
            gridStyle.rowGap = typeof rowGap === 'number' ? `${rowGap}px` : rowGap
        }
        if (columnGap !== undefined) {
            gridStyle.columnGap = typeof columnGap === 'number' ? `${columnGap}px` : columnGap
        }
    }

    return (
        <div className={gridClassName} style={gridStyle} {...props}>
            {children}
        </div>
    )
}

export default ScoopGrid
